// NiksFit's own package catalog data — see common/utils/packageCatalog.js for what these
// fields mean and how they're used. Kept in sync with the NiksFit Admin App's package setup
// (admin.niksfitnessstudio.rs/packages) — no multi-vežbač packages exist there yet, so unlike
// HitFit's catalog, there's nothing beyond the single-vežbač tiers.
export const PACKAGE_CATALOG = [
  {
    key: "trial",
    name: "Besplatna proba",
    people: 1,
    sessionsPerPerson: [1],
    price: 0,
    matchServiceQty: null,
    isTrial: true,
    featured: false,
  },
  {
    key: "single",
    name: "Pojedinačni trening",
    people: 1,
    sessionsPerPerson: [1],
    price: 900,
    matchServiceQty: 1,
    featured: false,
  },
  {
    key: "p1-4",
    name: "4 termina",
    people: 1,
    sessionsPerPerson: [4],
    price: 3500,
    matchServiceQty: 4,
    featured: false,
  },
  {
    key: "p1-6",
    name: "6 termina",
    people: 1,
    sessionsPerPerson: [6],
    price: 4250,
    matchServiceQty: 6,
    featured: false,
  },
  {
    key: "p1-8",
    name: "8 termina",
    people: 1,
    sessionsPerPerson: [8],
    price: 7000,
    matchServiceQty: 8,
    featured: false,
  },
  {
    key: "p1-12",
    name: "12 termina",
    people: 1,
    sessionsPerPerson: [12],
    price: 8500,
    matchServiceQty: 12,
    featured: true,
  },
];
